import React, { useState } from "react";
import {
  Header,
  Avatar,
  BadgeComponents,
  getIcon,
} from "@dishopsaas/design-system";
import { useTheme, Box, Typography } from "@mui/material";
import { getAddress, getTodayOpeningStatus } from "../InfoBar.services";
import { InfoBarHookReturn } from "../../../1_types/InfoBarTypes";
import { infoBarMobileStyles, mobileDetailsStyle } from "../InfoBar.styles";
import { BLACK } from "../../../constants";
import { MobileMenuDrawer } from "./MobileMenuDrawer";
import renderOrderType from '../../Order/components/orderType'
import { useUserDropdown } from "../../../hooks/useUserDropdown";
import CloseButton from '../../CloseButton';
import { isQrCode } from '../../../utils';
import ShopHeaderContent from "./ShopHeaderContent";
import { useAppSelector } from "../../../redux/hook";
export const InfoBarMobile: React.FC<
  InfoBarHookReturn & { withoutAddress?: boolean }
> = ({
  nbCommande,
  handlers,
  logoUrl,
  userConnected,
  orderType,
  withoutAddress = false,
  user,
  isOrderTracking = false,
  name,
  isClosedShop,
  openHours
}) => {
    const theme = useTheme();
    const styles = infoBarMobileStyles(theme);
    const [drawerOpen, setDrawerOpen] = useState(false);
    const { goToOrders } = useUserDropdown()
    const { text, isOpen } = getTodayOpeningStatus(openHours, isClosedShop);
    const { pendingOrderReducer, configurationReducer, shopReducer } = useAppSelector((s) => s);
    const { address } = pendingOrderReducer;
    const { theme: themeConfiguration, google, secondaryColor, orderTypes } = configurationReducer;
    const { addressShop, shopName } = shopReducer;
    return (
      <>
        <Header
          leftElement={
            isQrCode() ? <>
              <Avatar src={logoUrl} size="md" shape="rounded" />
              {!withoutAddress &&
                <Typography variant='subtitle2' sx={styles.shopName}>{name}</Typography>
              }
            </> : (
              isOrderTracking ? <div></div> : (
                <>
                  <Box
                    sx={styles.menu}
                    onClick={() => {
                      if (userConnected) {
                        setDrawerOpen(true);
                      } else {
                        handlers.handleOpenLogin();
                      }
                    }}
                  >
                    {getIcon("Menu", { size: 20, color: theme.palette.text.primary })}
                  </Box>
                  {!withoutAddress &&
                    <ShopHeaderContent
                      logoUrl={null}
                      name={name}
                      text={text}
                      isOpen={isOpen}
                      showTextsLg={true}
                      styles={styles}
                      address={address}
                      addressShop={addressShop}
                      orderType={orderType}
                      theme={themeConfiguration}
                      googleApiKey={google.apiKey}
                      secondaryColor={secondaryColor}
                      orderTypes={orderTypes}
                      openHours={openHours}
                      shopName={shopName}
                      isQrCode={isQrCode()}
                    />
                  }
                </>
              )
            )
          }
          centerElement={
            !isQrCode() &&
            <>
              {withoutAddress &&
                <Avatar src={logoUrl} size="md" shape="rounded" />

              }
            </>
          }
          rightElement={
            isOrderTracking ?
              <CloseButton onClick={() => goToOrders()}></CloseButton>

              : <Box
                sx={{ px: "16px", cursor: "pointer" }}
                onClick={handlers.handleCartClick}
              >
                <BadgeComponents.CounterBadge
                  content={nbCommande || 0}
                  color={nbCommande ? "primary" : BLACK}
                  showZero
                >
                  <Box>
                    <BadgeComponents.Placeholder />
                  </Box>
                </BadgeComponents.CounterBadge>
              </Box>
          }
          containerStyle={{ ...styles.headerTop, padding: withoutAddress ? '16px!important' : '8px 16px!important' }}
          detailStyle={mobileDetailsStyle}
        />
        {!withoutAddress && (
          <Box sx={styles.headerBottom}>
            <Box sx={styles.bottomBlock} onClick={handlers.openAddress}>
              {renderOrderType(orderType, false, 16, 'subtitle1')}
              <Box sx={{ ...styles.address, marginLeft: "auto" }}>
                <Typography variant="caption" sx={{ fontWeight: 700, ...styles.typo }}>
                  {getAddress()}
                </Typography>
              </Box>

            </Box>
          </Box>
        )}
        <MobileMenuDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          user={user}
        />
      </>
    );
  };
